module.exports = __webpack_public_path__ + "static/media/6.03479603.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/6.jpg
// module id = 1738
// module chunks = 0